import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// SUPPLIER PO STATUS RELATED APIs
// ==============================================

// 1. Get View Purchase Status Grid
export const getViewPurchaseStatusGrid = async (params) => {
    try {
        const { CCode, Fromdate, Todate, UID, RID } = params;
         // DEBUG
        
        // Validate required parameters
        if (!UID || !RID) {
            throw new Error('UID and RID are required parameters');
        }
        
        const queryParams = new URLSearchParams({
            CCode: CCode || '',
            Fromdate: Fromdate || '',
            Todate: Todate || '',
            UID: UID,
            RID: RID
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/ViewPurchaseStatusGrid?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Purchase Cost Center Codes
export const getPurchaseCostCenterCodes = async (params) => {
    try {
        const { UID, RID } = params;
         // DEBUG
        
        // Validate required parameters
        if (!UID || !RID) {
            throw new Error('UID and RID are required parameters');
        }
        
        const queryParams = new URLSearchParams({
            UID: UID,
            RID: RID
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetPurchaseCostCenterCodes?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};